import { useConversationStore } from '../../../stores';
import { Spinner } from '../../../components';
import ChatHeader from './ChatHeader';
import MessageList from './MessageList';
import MessageInput from './MessageInput';
import { useMessages } from '../hooks/useMessages';
import { useConversationSubscription } from '../../../lib/websocket';

export default function ChatInterface() {
  const { selectedConversationId, getConversation } = useConversationStore();

  const conversation = selectedConversationId
    ? getConversation(selectedConversationId)
    : null;

  const {
    messages,
    isLoading,
    sendMessage,
    isSending,
    editMessage,
    deleteMessage,
    hasMore,
    loadMore,
    loadingMore,
  } = useMessages(selectedConversationId);

  // Subscribe to conversation updates
  useConversationSubscription(selectedConversationId);

  if (!selectedConversationId || !conversation) {
    return (
      <div className="flex h-full items-center justify-center bg-paper">
        <div className="text-center">
          <p className="text-lg font-medium text-ink">No conversation selected</p>
          <p className="mt-1 text-sm text-ink-2">
            Select a conversation from the list to start
          </p>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner text="Loading messages..." />
      </div>
    );
  }

  return (
    <div className="flex h-full flex-col bg-paper">
      <ChatHeader conversation={conversation} />
      <MessageList
        messages={messages}
        conversationId={selectedConversationId}
        hasMore={hasMore}
        loadMore={loadMore}
        loadingMore={loadingMore}
        onEditMessage={async (id, content) => {
          const result = await editMessage({ messageId: id, content });
          if (!result.channelPropagated) {
            alert(
              "Saved on the dashboard, but the channel didn't accept the edit, so the customer still sees the original. (Common for WhatsApp Cloud — it doesn't let business senders edit sent messages.)",
            );
          }
        }}
        onDeleteMessage={async (id) => {
          if (!window.confirm('Withdraw this AI message? It will be marked as removed in this conversation.')) return;
          const result = await deleteMessage(id);
          if (!result.channelPropagated) {
            alert(
              "Withdrawn in the dashboard. The channel didn't accept the revoke, so the customer still sees the original. (Common for WhatsApp Cloud — it doesn't expose business-side delete.)",
            );
          }
        }}
      />
      <MessageInput onSend={sendMessage} isSending={isSending} />
    </div>
  );
}
